export default __webpack_public_path__ + "media/images/react_icons/arrow-dates-right-black-40f4b5051f6367239be43dd55e68daeb.svg";